import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import clearNotNumber from '@vr/devkit/utils/clearNotNumber';
import { Grid } from '@material-ui/core';
import { Button } from '~/elements';
import { Modal } from '~/components';
import Pergunta from '~/components/Pergunta';
import {
  finishIndicacaoRequest,
  reset,
} from '~/store/modules/indicacao/actions';
import getMessagePopup from '~/helpers/getMessagePopup';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';

const Form = styled.form`
  margin-top: 30px;

  fieldset {
    border: none;
  }
  legend {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary}
    margin-bottom: 1rem;
  }
`;
const ContainerButton = styled(Grid)`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
`;
const ModalContent = styled.div`
  background-color: ${({ theme }) => theme.colors.institucional};
  color: white;
  padding: 20px 30px;
`;
const ModalButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export default function FormIndicacaoProdutos({ history }) {
  const dispatch = useDispatch();
  const breadcrumbs = useContext(BreadcrumbsContext);

  const [isValid, setIsValid] = useState(false);
  const [showError, setShowError] = useState(false);
  const [modal, setModal] = useState({});

  const form = useSelector(state => state.indicacao);
  const perguntas = useSelector(state => state.perguntas);
  const showModal = useSelector(state => state.indicacao.showModal);
  const todosProdutos = useSelector(state => state.produtos);
  const user = useSelector(state => state.user);

  const produtosAtivos = todosProdutos.filter(
    prod => form.produtos.indexOf(Number(prod.codigo)) >= 0,
  );
  const produtosInativos = todosProdutos.filter(
    prod => form.produtos.indexOf(Number(prod.codigo)) === -1,
  );

  const produtos = {
    TODOS_PRODUTOS: todosProdutos,
    PRODUTO_ATIVO: produtosAtivos,
    PRODUTO_INATIVO: produtosInativos,
  };

  function setBreadcrumb(icon, label) {
    breadcrumbs.setBreadcrumb({
      icon,
      label,
    });
  }

  useEffect(() => {
    setBreadcrumb('store', 'Indique um estabelecimento');
    return () => setBreadcrumb();
    // eslint-disable-next-line
  }, []);

  function validate() {
    const perguntasObrigatorias = perguntas.filter(
      pergunta => pergunta.required,
    );

    if (perguntasObrigatorias.length === 0) {
      return true;
    }

    let status = true;
    perguntasObrigatorias.forEach(pergunta => {
      const [item] = form.respostas.filter(
        resposta => resposta.codigo === pergunta.code,
      );

      if (!item || item.produtos.length === 0) {
        status = false;
      }
    });

    return status;
  }

  function validateOnChange() {
    setIsValid(validate());
  }

  useEffect(validateOnChange, [form.respostas]);

  useEffect(() => {
    if (showModal) {
      setModal(getMessagePopup(perguntas, form));
    }
  }, [showModal, perguntas, form]);

  function handleCloseModal() {
    dispatch(reset());
    history.push('/home');
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (validate()) {
      const { name, email, cpf } = user;
      const post = {
        ...form,
        indicadosPor: [
          {
            nomeIndicador: name,
            emailIndicador: email,
            documentoIndicador: cpf,
            tipoDocumento: 'CPF',
          },
        ],
        cnpjCpfEc: String(clearNotNumber(form.cnpj)),
        numeroTelefoneContato: String(clearNotNumber(form.telefone)),
        tipoEc: form.categoria.label,
        respostas: form.respostas.map(resposta => ({
          pergunta: resposta.codigo,
          valorResposta: resposta.produtos,
        })),
      };

      delete post.step;
      delete post.showModal;
      delete post.tipo;
      delete post.categoria;
      delete post.status;
      delete post.produtos;
      delete post.ecNovo;
      delete post.telefone;
      delete post.cnpj;
      delete post.latitude;
      delete post.longitude;

      dispatch(finishIndicacaoRequest(post));
    } else {
      setIsValid(false);
      setShowError(true);
    }
  }

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate id="form-indicacao-perguntas">
        <fieldset>
          <legend>Dados de utilização</legend>
        </fieldset>
        {perguntas.map(
          (
            { code, label, type, required, tipoRespostaPadrao, respostaPadrao },
            index,
          ) => (
            <Pergunta
              key={`pergunta-${code}`}
              code={code}
              question={index + 1}
              label={label}
              type={type}
              products={produtos[type]}
              required={required}
              showError={showError}
              hasRespostaPadrao={tipoRespostaPadrao}
              respostaPadrao={respostaPadrao}
            />
          ),
        )}
        <ContainerButton>
          <Button
            label="Concluir Indicação"
            type="submit"
            variant="contained"
            disabled={!isValid}
          />
        </ContainerButton>
      </Form>
      <Modal open={showModal} handleClose={handleCloseModal}>
        <ModalContent>
          <h2>{modal.title}</h2>
          <p>{modal.message}</p>
          <ModalButton>
            <Button
              label="Acessar página inicial"
              variant="contained"
              onClick={handleCloseModal}
            />
          </ModalButton>
        </ModalContent>
      </Modal>
    </>
  );
}

FormIndicacaoProdutos.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};
